module.exports = __webpack_public_path__ + "static/media/BonfantiХL265CE.c305755c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/BonfantiХL265CE.jpg
// module id = 151
// module chunks = 0